import { render, staticRenderFns } from "./ProductInfoTable.vue?vue&type=template&id=d4059710&scoped=true&"
import script from "./ProductInfoTable.vue?vue&type=script&lang=js&"
export * from "./ProductInfoTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoTable.vue?vue&type=style&index=0&id=d4059710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4059710",
  null
  
)

export default component.exports